import * as React from 'react';
import moment from 'moment';
import classnames from 'classnames';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';
import CampaignPayoutsInstallmentsModal from '../../modals/installments/CampaignPayoutsInstallmentsModal';
import StatusLabel from 'components/status-label/StatusLabel';

import { renderPrice } from 'utils/helper/price';
import { __t, applyTranslations } from 'utils/language';
import { getAcceptedOfferBudget, getTotalVariablePayment } from 'utils/payouts';

import './campaign-payouts-list-unallocated.scss';

import type { Campaign, PaymentInfo, Subcampaign } from 'types';

applyTranslations(require('./campaign-payouts-list-unallocated.i18n.json'));

const ActionButtonWithModalInstallments = withModal(ActionButton, {
  modalContent: CampaignPayoutsInstallmentsModal
});

const msgKey = 'campaign_payouts_list_unallocated';

type Props = {
  campaign: Campaign,
  subcampaign: Subcampaign,
  paymentInfo?: PaymentInfo,
  remainingTotal: number,
  endDate?: moment.Moment | null,
  isBrand: boolean
};

class CampaignPayoutsListUnallocated extends React.PureComponent<Props> {
  static defaultProps = {
    isBrand: false
  };

  renderBrandView(): React.ReactNode {
    const { campaign, subcampaign, remainingTotal, paymentInfo } = this.props;
    const variablePayment = getTotalVariablePayment(paymentInfo);

    const budgetClasses = classnames('campaign-payouts-list-unallocated__item', {
      'campaign-payouts-list-unallocated__item--over-budget': remainingTotal < 0
    });

    return (
      <div className="campaign-payouts-list-unallocated__brand">
        <div className="campaign-payouts-list-unallocated__item">
          {__t(`${msgKey}.labels.unallocated_payout`)}
        </div>
        <div className={budgetClasses}>
          {renderPrice(remainingTotal)}
        </div>
        <div className="campaign-payouts-list-unallocated__item">
          &mdash;
        </div>
        <div className="campaign-payouts-list-unallocated__item">
          &mdash;
        </div>
        <div className="campaign-payouts-list-unallocated__item">
          &mdash;
        </div>
        <div className="campaign-payouts-list-unallocated__item">
          <ActionButtonWithModalInstallments
            modalContentProps={{
              influencerProfile: subcampaign.creatorProfile,
              campaignId: campaign.id,
              subcampaignId: subcampaign.id,
              totalBudget: getAcceptedOfferBudget(subcampaign) + variablePayment,
              campaignEndDatetime: campaign.endDate
            }}
          >
            {__t(`${msgKey}.buttons.allocate`)}
          </ActionButtonWithModalInstallments>
        </div>
      </div>
    );
  }

  renderInfluencerView(): React.ReactNode {
    const { remainingTotal, endDate } = this.props;
    const isExpectedDayPassed = endDate ? moment().isAfter(endDate) : false;

    return (
      <div className="campaign-payouts-list-unallocated__influencer">
        <div className="campaign-payouts-list-unallocated__item">
          {renderPrice(remainingTotal)}
        </div>
        <div className="campaign-payouts-list-unallocated__item">
          {__t('campaign_payouts_list_unallocated.labels.not_yet_released')}
        </div>
        {
          isExpectedDayPassed && (
            <StatusLabel
              type="warning"
              label={__t(`${msgKey}.labels.pending`)}
              size="small"
              data={{ qa: 'campaign-payouts-list-item__status-label--pending-unallocated' }}
            />
          )
        }
      </div>
    );
  }

  render(): React.ReactNode {
    const { isBrand } = this.props;

    return (
      <div
        className="campaign-payouts-list-unallocated"
        data-qa="campaign-payouts-list-unallocated"
      >
        {
          isBrand
            ? this.renderBrandView()
            : this.renderInfluencerView()
        }
      </div>
    );
  }
}

export default CampaignPayoutsListUnallocated;
